export default "__VITE_ASSET__CxsQI0ax__"